<template>
  <v-app :dark="dark" id="app">
    <router-view />
  </v-app>
</template>

<script>
export default {
  name: 'MainLayout',
  data: () => ({
    dark: true
  })
}
</script>
<style>
#app {
  background-color: #fbfcfb;
}
</style>
